import React from 'react';
import { t } from '@sm/intl';
import { DetailsFeatureRowPackages } from '~app/pages/Pricing/transformers/details/types';

import useCategoryStyles from './useStyles';
import COPY from './copy';

export default function FeatureCell(pkg: Readonly<DetailsFeatureRowPackages>): JSX.Element {
  const { Cell, Bullet } = useCategoryStyles({ packageName: pkg.packageName });
  let a11yValue = COPY.UNAVAILABLE.defaultMessage;

  if (typeof pkg.value === 'string') {
    a11yValue = pkg.value;
  } else if (pkg.value) {
    a11yValue = COPY.AVAILABLE.defaultMessage;
  }

  return (
    <div
      role="cell"
      aria-label={`${pkg.packageName} ${a11yValue}`}
      aria-roledescription={t(COPY.CELL_ARIA_ROLE_DESC_2792)}
      className={Cell}
      tabIndex={-1}
      data-testid="FeatureCell"
    >
      {typeof pkg.value === 'boolean' ? pkg.value && <span className={Bullet} /> : pkg.value}
    </div>
  );
}
